export default "__VITE_ASSET__CXfJZmXi__"